<div class="py-[40px] md:py-[70px] lg:py-[90px] xl:py-[110px]">
    <!-- <h1 class="text-center text-3xl font-bold">
        How it works
    </h1> -->
    <div class="container w-[80vw] mx-auto px-[12px] relative z-[1]">
        <!-- <div class="container md:max-w-[960px] 2xl:max-w-[1320px] mx-auto px-[12px] relative z-[1]"></div> -->
        <div class="text-left mx-auto w-[80vw]">
            <div class="my-[25px] md:my-[45px] md:flex z-[1] relative justify-between">
                <span class="block absolute bottom-0 md:bottom-auto ltr:left-[25px] ltr:md:left-0 ltr:md:right-0 rtl:right-[25px] rtl:md:right-0 rtl:md:left-0 top-[25px] -z-[1] border-t border-dashed border-primary-500 ltr:border-l ltr:md:border-l-0 rtl:border-l rtl:md:border-l-0"></span>
                <div>
                    <div class="rounded-full text-center font-semibold text-black dark:text-white w-[50px] h-[50px] leading-[48px] bg-white dark:bg-[#0c1427] border border-dashed border-primary-500">
                        01
                    </div>
                    <span class="block text-md mt-[17px] font-semibold text-black dark:text-white ltr:pl-[45px] rtl:pr-[45px] md:!p-0">
                        <!--i18n: Select your currency -->
                        {{ 'i18n.app.features.pages.front-pages.common.fp-process.span_01' | translate }}
                    </span>
                    <p class="block dark:text-gray-200 ltr:pl-[45px] rtl:pr-[45px] md:!p-0 block text-sm text-gray-500 mt-2 !mb-0">
                        <!--i18n: Choose from over 140 available currencies -->
                        {{ 'i18n.app.features.pages.front-pages.common.fp-process.p_01_01' | translate }}
                    </p>
                    <p class="text-sm text-gray-500 !mb-0">
                        <!--i18n: Specify the desired amount for your trip -->
                        {{ 'i18n.app.features.pages.front-pages.common.fp-process.p_01_02' | translate }}
                    </p>
                    <p class="text-sm text-gray-500 !mb-0">
                        <!--i18n: View exchange rates before confirming -->
                        {{ 'i18n.app.features.pages.front-pages.common.fp-process.p_01_03' | translate }}
                    </p>
                </div>
                <div>
                    <div class="rounded-full text-center font-semibold text-black dark:text-white w-[50px] h-[50px] leading-[48px] bg-white dark:bg-[#0c1427] border border-dashed border-primary-500">
                        02
                    </div>
                    <span class="block text-md mt-[17px] font-semibold text-black dark:text-white ltr:pl-[45px] rtl:pr-[45px] md:!p-0">
                        <!--i18n: Choose your office -->
                        {{ 'i18n.app.features.pages.front-pages.common.fp-process.span_02' | translate }}
                    </span>
                    <p class="text-sm text-gray-500 !mb-0">
                        <!--i18n: Select the BPOST office where you want to collect your order -->
                        {{ 'i18n.app.features.pages.front-pages.common.fp-process.p_02_01' | translate }}
                    </p>
                    <p class="text-sm text-gray-500 !mb-0">
                        <!--i18n: Over 130 offices available throughout Belgium -->
                        {{ 'i18n.app.features.pages.front-pages.common.fp-process.p_02_02' | translate }}
                    </p>
                    <p class="text-sm text-gray-500 !mb-0">
                        <!--i18n: Check opening hours directly on the platform -->
                        {{ 'i18n.app.features.pages.front-pages.common.fp-process.p_02_03' | translate }}
                    </p>
                </div>
                <div>
                    <div class="rounded-full text-center font-semibold text-black dark:text-white w-[50px] h-[50px] leading-[48px] bg-white dark:bg-[#0c1427] border border-dashed border-primary-500">
                        03
                    </div>
                    <span class="block text-md mt-[17px] font-semibold text-black dark:text-white ltr:pl-[45px] rtl:pr-[45px] md:!p-0">
                        <!--i18n: Pay Online -->
                        {{ 'i18n.app.features.pages.front-pages.common.fp-process.span_03' | translate }}
                    </span>
                    <p class="text-sm text-gray-500 !mb-0">
                        <!--i18n: Complete your payment securely with Stripe -->
                        {{ 'i18n.app.features.pages.front-pages.common.fp-process.p_03_01' | translate }}
                    </p>
                    <p class="text-sm text-gray-500 !mb-0">
                        <!--i18n: You will receive instant confirmation by email -->
                        {{ 'i18n.app.features.pages.front-pages.common.fp-process.p_03_02' | translate }}
                    </p>
                    <p class="text-sm text-gray-500 !mb-0">
                        <!--i18n: Track your order preparation status in real time -->
                        {{ 'i18n.app.features.pages.front-pages.common.fp-process.p_03_03' | translate }}
                    </p>

                </div>
                <div>
                    <div class="rounded-full text-center font-semibold text-white w-[50px] h-[50px] leading-[48px] bg-primary-500 border border-dashed border-primary-500">
                        04
                    </div>
                    <span class="block text-md mt-[17px] font-semibold text-black dark:text-white ltr:pl-[45px] rtl:pr-[45px] md:!p-0">
                        <!--i18n: Collect your currency -->
                        {{ 'i18n.app.features.pages.front-pages.common.fp-process.span_04' | translate }}
                    </span>
                    <p class="text-sm text-gray-500 !mb-0">
                        <!--i18n: Once your order is ready, go to your chosen office -->
                        {{ 'i18n.app.features.pages.front-pages.common.fp-process.p_04_01' | translate }}
                    </p>
                    <p class="text-sm text-gray-500 !mb-0">
                        <!--i18n: Identify yourself with itsMe from your mobile -->
                        {{ 'i18n.app.features.pages.front-pages.common.fp-process.p_04_02' | translate }}
                    </p>
                    <p class="text-sm text-gray-500 !mb-0">
                        <!--i18n: Collect your sealed envelope containing your currency -->
                        {{ 'i18n.app.features.pages.front-pages.common.fp-process.p_04_03' | translate }}
                    </p>
                </div>
            </div>
        </div>
        <div class="absolute ltr:left-[10px] rtl:right-[10px] -top-[200px] -z-[1] blur-[150px]">
            <img src="images/front-pages/shape7.png" alt="shape7">
        </div>
        <!-- <div class="absolute ltr:right-[25px] rtl:left-[25px] top-[150px] -z-[1] blur-[125px] hidden md:block">
            <img src="images/front-pages/shape8.png" alt="shape8">
        </div> -->
    </div>
</div>

